import { render, staticRenderFns } from "./BaaGuidedWizard.vue?vue&type=template&id=6ae78886&scoped=true&"
import script from "./BaaGuidedWizard.vue?vue&type=script&lang=js&"
export * from "./BaaGuidedWizard.vue?vue&type=script&lang=js&"
import style0 from "./BaaGuidedWizard.vue?vue&type=style&index=0&id=6ae78886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae78886",
  null
  
)

export default component.exports